/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EstadisticasController', EstadisticasController);

    /* @ngInject */
    function EstadisticasController($timeout, $stateParams, Estadisticas, Principal) {

        var vm = this;

        // Estadisticas

        Estadisticas.getEstadisticas().$promise.then(function(result) {

            vm.ejemplaresRevisadosPublicados = addDots(result.ejemplaresRevisadosPublicados);
            vm.ejemplaresNoRevisadosNoPublicados = addDots(result.ejemplaresNoRevisadosNoPublicados);
            vm.obrasAutor = addDots(result.obrasAutor);
            vm.obrasNoAutor = addDots(result.obrasNoAutor);

        });

    }

    function addDots (number) {

        var numberStr = String(number);
        var numberNew = "";


        for (var i = numberStr.length - 1; i >= 0; i--) {

            numberNew = numberStr[i] + numberNew;
            if (i != numberStr.length - 1 && i != 0 && (numberStr.length - i) % 3 == 0) numberNew = "." + numberNew;

        }

        return numberNew;

    }

})(angular);
